export const enumConfig = {
    headerTipEnum:{         
        "technician":{
            text:"【亿合道技师】",
            page:'【亿合道技师】',
            img:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/technician.png",
        },
        "technician2":{
            text:"【亿合道技师】",
            page:'【亿合道技师】',
            img:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/technician2.png",
        },
        "technicianService":{
            text:"支持服务",
            page:'支持服务',
            img:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/technicianService.png",
        },
        "service-type":{
            text:"服务类型",
            page:'服务类型',
            img:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/ServiceType.png",
        },
        "service-primary":{
            text:"服务大项",
            page:'服务大项',
            img:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/MajorServiceCategory.jpg",
        },
        "service-project":{
            text:"服务项目",
            page:'服务项目',
            img:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/ServiceItem.png",
        },
    },
    CommonStateEnum : [
        { label: '启用', value: 0 },
        {label: '禁用', value: 1 }
    ],
    //技师在职状态
    TechnicianJobEnum:[
        { value: 0, label: '在职' },
        { value: 10, label: '离职' }
    ],
    activeFlags:[
        { value: 1, label: '在职' },
        { value: 0, label: '离职' }
    ],
    //技师在线状态
    TechnicianOnlineEnum :[
        { value: 1, label: '在线' },
        { value: 10, label: '下线' }
    ],  
    roleTypeList: [
      { value: 1, label: "车主" ,code:'owner',invoiceContent:'运输费用'},
      { value: 10, label: "技师" ,code:'technician'},
      { value: 20, label: "平台" ,code:'platform'},
      { value: 30, label: "投资者" ,code:'investor'},
      { value: 40, label: "货车司机" ,code:'driver',invoiceContent:'运输费用'},
      { value: 50, label: "门店" ,code:'store'},
      { value: 60, label: "供应商" ,code:'supplier',invoiceContent:'商品费用'},
      { value: 70, label: "司机" ,code:'trucker',invoiceContent:'运输费用'},
    //   { value: '', label: "商家" ,code:'merchant'},
    //   { value: '', label: "运营组织" ,code:'operation'},
    ],
    sysRoleTypeList: [
      { value: 20, label: "平台" ,code:'platform'},
      { value: 30, label: "投资者" ,code:'investor'},
      { value: 40, label: "货车司机" ,code:'driver',invoiceContent:'运输费用'},
      { value: 60, label: "供应商" ,code:'supplier',invoiceContent:'商品费用'},
    ],  
    //提现用
    financeRoleTypeList: [
      { value: 10, label: "技师" ,code:'technician'},
      { value: 30, label: "投资者" ,code:'investor'},
      { value: 40, label: "货车司机" ,code:'driver',invoiceContent:'运输费用'},
      { value: 60, label: "供应商" ,code:'supplier',invoiceContent:'商品费用'},
    ],  
    orderStateList: [
      { value: 1, label: "待支付" },
      { value: 10, label: "待技师接单" },
      { value: 20, label: "待技师接单-客户改期，技师确认中" },
      { value: 30, label: "待技师接单-客户改期，技师同意改期" },
      { value: 40, label: "待技师接单-客户改期，技师拒绝改期" },
      { value: 50, label: "待技师上门" },
      { value: 60, label: "待技师上门-客户改期，技师确认中" },
      { value: 70, label: "待技师上门-技师同意改期" },
      { value: 80, label: "待技师上门-技师拒绝改期" },
      { value: 90, label: "待技师上门-技师改期，待客户确认" },
      { value: 100, label: "技师上门-客户同意改期" },
      { value: 110, label: "待技师上门-客户拒绝改期" },
      { value: 120, label: "技师上门中" },
      { value: 130, label: "技师服务中" },
      { value: 140, label: "服务已完成-等待客户确认" },
      { value: 150, label: "服务中-方案待客户确认" },
      { value: 160, label: "服务中-客户拒绝方案变更" },
      { value: 170, label: "服务中-客户同意方案变更" },
      { value: 180, label: "服务中-待客户确认二次上门" },
      { value: 190, label: "待二次上门" },
      { value: 200, label: "服务中-客户拒绝二次上门" },
      { value: 210, label: "已取消" },
      { value: 220, label: "商家审核中" },
      { value: 230, label: "商家拒绝取消订单" },
      { value: 240, label: "客户取消订单-退款中" },
      { value: 250, label: "客户取消订单-退款成功" },
      { value: 260, label: "客户超时支付-退款中" },
      { value: 270, label: "客户超时支付-已取消" },
      { value: 280, label: "技师超时未接单-退款中" },
      { value: 290, label: "技师超时未接单-退款成功" },
      { value: 300, label: "技师取消订单-退款中" },
      { value: 310, label: "技师取消订单-退款成功" },
      { value: 320, label: "服务中-客户拒绝完成订单" },
      { value: 330, label: "已完成" },
      { value: 340, label: "平台取消订单-退款中" },
      { value: 350, label: "平台取消订单-退款完成" },
    ],    
    orderStateListTree: [
      { value: 1, label: "待支付" },
      { value: "10,20,30,40", label: "待技师接单", 
        children:[
          { value: 10, label: "待技师接单" },
          { value: 20, label: "待技师接单-客户改期，技师确认中" },
          { value: 30, label: "待技师接单-客户改期，技师同意改期" },
          { value: 40, label: "待技师接单-客户改期，技师拒绝改期" },
        ]
       }, 

      { value: "50,60,70,80,90,100,110", label: "待技师上门" ,
        children:[
          { value: 50, label: "待技师上门" },
          { value: 60, label: "待技师上门-客户改期，技师确认中" },
          { value: 70, label: "待技师上门-技师同意改期" },
          { value: 80, label: "待技师上门-技师拒绝改期" },
          { value: 90, label: "待技师上门-技师改期，待客户确认" },
          { value: 100, label: "技师上门-客户同意改期" },
          { value: 110, label: "待技师上门-客户拒绝改期" },
        ]
      }, 
      { value: 120, label: "技师上门中" },
      { value: "130,140,150,160,170,180,200,320", label: "技师服务中",
        children:[
          { value: 130, label: "技师服务中" },          
          { value: 150, label: "方案待客户确认" },
          { value: 160, label: "客户拒绝方案变更" },
          { value: 170, label: "客户同意方案变更" },
          { value: 180, label: "待客户确认二次上门" },
          { value: 200, label: "客户拒绝二次上门" },
          { value: 140, label: "等待客户确认服务完成" },
          { value: 320, label: "服务中客户拒绝完成订单" },
        ]
       },
      { value: 190, label: "待技师二次上门" },
      { value: 260, label: "客户超时支付-退款中" },
      { value: 270, label: "客户超时支付--已取消" },
      { value: "220,230,240,250,280,290,300,310,340,350", label: "售后/退款" ,
        children:[          
          { value: 220, label: "商家审核中" },
          { value: 230, label: "商家拒绝取消订单" },
          { value: 240, label: "客户取消订单-退款中" },
          { value: 250, label: "客户取消订单-退款成功" },
          { value: 300, label: "技师取消订单-退款中" },
          { value: 310, label: "技师取消订单-退款成功" },
          { value: 340, label: "平台取消订单-退款中" },
          { value: 350, label: "平台取消订单-退款完成" },
          { value: 280, label: "技师超时未接单-退款中" },
          { value: 290, label: "技师超时未接单-退款成功" },
        ]
      }, 
      { value: 210, label: "客户取消订单" },
      { value: 330, label: "已完成" },
    ],
    // 账户状态  0待审核 10可接单 20审核拒绝 30停用	
    jishiAccountStatusList: [
      { value: 0, label: "待审核", color: "info" },
      { value: 10, label: "可接单", color: "success" },
      { value: 20, label: "审核拒绝", color: "danger" },
      { value: 30, label: "停用", color: "info" },
    ],
    // 货车司机状态  0待审核，10=可接单，20=审核拒绝，30=停用，40=封禁
    driverAccountStatusList: [
      { value: 0, label: "待审核", color: "info" },
      { value: 10, label: "可接单", color: "success" },
      { value: 20, label: "审核拒绝", color: "danger" },
      { value: 30, label: "停用", color: "info" },
      { value: 40, label: "封禁", color: "danger" },
    ],
    
    //技师来源 1-小程序注册 2-投资者添加
    technicianSourceList: [
      { value: 1, label: "小程序注册" },
      { value: 2, label: "投资者添加" },
    ],
    // 技师审核状态 0待审核 1-审核通过 2-审核驳回
    technicianAuditStateList: [
      { value: 0, label: "待审核", color: "info" },
      { value: 1, label: "审核通过", color: "success" },
      { value: 2, label: "审核驳回", color: "danger" },
    ],
    qualificationStatusList: [
      { value: 0, label: "待审核", color: "info" },
      { value: 1, label: "生效中", color: "success" },
      { value: 2, label: "已废弃", color: "danger" },
    ],
    // flagList
    flagList: [
      { value: "是", label: "是" },
      { value: "否", label: "否" },
    ],
    numFlagList: [
      { value: "1", label: "是" },
      { value: "0", label: "否" },
    ],
    // 性别
    sexList: [
      { value: "男", label: "男" },
      { value: "女", label: "女" },
    ],
    // 商品来源   0 工厂来源 1 投资者自己商品
    factorySourceList: [
      // { label: "自营耗材", value: 0 },
      // { label: "供应商提供耗材（商城提供的耗材）", value: 1 }
      { label: "商城商品", value: 0 },
      { label: "投资者自带", value: 1 }
    ],
    // 服务项目状态
    serviceStateList: [
      { value: 0, label: "未发布" },
      { value: 1, label: "已发布" },
      { value: 10, label: "废弃" },
    ],
    // 角色数据类型
    roleCodeList: [
    ],
    // ERP用户 1正常 2锁定 3停用
    erpUserStatusList: [
      { value: 1, label: "正常" },
      { value: 2, label: "锁定" },
      { value: 3, label: "停用" },
    ],
    // 投资者用户状态 1正常 2锁定 3停用
    investorUserStatusList: [
      { value: 1, label: "正常" },
      { value: 2, label: "锁定" },
      { value: 3, label: "停用" },
    ],
    // 订单退款状态
    OrderRefundStateList: [
      { value: 1, label: "审核中" },
      { value: 10, label: "审批成功退款中" },
      { value: 20, label: "退款成功" },
      { value: 30, label: "拒绝退款" },
      { value: 40, label: "用户已取消退款" },
    ],
    // 订单退款类型
    OrderRefundTypeList: [
      { value: 0, label: "消费者取消订单" ,code:"CONSUMER_CANCEL_ORDER"},
      { value: 1, label: "技师取消订单" ,code:"TECHNICIAN_CHANGE_ORDER"},
      { value: 10, label: "平台取消订单" ,code:"PLATFORM_CANCEL_ORDER"},
    ],
    // 订单日志类型
    OrderLogTypeList: [
      { value: 0, label: "订单提交成功" ,code:"CONSUMER_SAVE_ORDER"},
      { value: 1, label: "消费者取消订单" ,code:"CONSUMER_CANCEL_ORDER"},
      { value: 10, label: "消费者撤销取消订单申请" ,code:"CONSUMER_REVOKE_CANCEL_ORDER"},
      { value: 20, label: "消费者修改上门时间" ,code:"CONSUMER_UPDATE_DOOR_TO_DOOR_TIME"},
      { value: 30, label: "技师修改上门时间" ,code:"TECHNICIAN_UPDATE_DOOR_TO_DOOR_TIME"},
    ],

    //退款原因  reasonType 1个人原因 10商家原因 100其他原因
    cancelOrderReasonTypeList: [
      { value: 1, label: "个人原因" },
      { value: 10, label: "商家原因" },
      { value: 100, label: "其他原因" },
    ],
    // 账单状态  0待生成账单 1待审批 10已入账余额
    settleStatusList: [
      { value: 0, label: "待生成账单" },
      { value: 1, label: "待审批" },
      { value: 10, label: "已入账余额" },
    ],
    // 发票状态 1:待开票 10:已开票 20:已取消
    invoiceStatusList: [
      { value: 1, label: "待开票" },
      { value: 10, label: "已开票" },
      { value: 20, label: "已取消" },
    ],
    //0商家未开票 1:待开票 10:已开票 20:已取消
    settleInvoiceStatusList: [
      { value: 0, label: "商家未开票" },
      { value: 1, label: "待开票" },
      { value: 10, label: "已开票" },
      { value: 20, label: "已取消" },
    ],
    // 发票类型 1:电子普通发票 2:电子专用发票
    invoiceTypeList: [
      { value: 1, label: "电子普通发票" },
      { value: 2, label: "电子专用发票" },
    ],
    // 抬头类型 1:个人/事业单位 2:企业
    titleTypeList: [
      { value: 1, label: "个人/非企业单位" },
      { value: 2, label: "企业单位" },
    ],
    // 提现状态
    withdrawStatusList: [
      { value: "REQUEST_RECEIVE", label: "已受理" },
      { value: "REQUEST_ACCEPT", label: "处理中" },
      { value: "REMITING", label: "打款中" },
      { value: "SUCCESS", label: "已到账" },
      { value: "FAIL", label: "提现失败" },
    ],//到账类型选项
    receiveTypeList: [
      { value: 'REAL_TIME', label: "实时到账" },
      { value: 'TWO_HOUR', label: "2小时到账" },
      { value: 'NEXT_DAY', label: "次日到账" },
    ],
    // 入网状态
    merchantRegisterStatusList: [
      { value: "AUDITING", label: "审核中" },
      { value: "COMPLETED", label: "已通过" },
      { value: "AUDIT_BACK", label: "已驳回" },
      // { value: "FAILED", label: "审核失败" },
    ],
    //入网类型：MICRO（个人）/ COMPANY（公司）
    merchantRegisterTypeList: [
      { value: "MICRO", label: "个人" },
      { value: "COMPANY", label: "公司" },
    ],
    //证件类型
    legalLicenceTypeList: [
      { value: "ID_CARD", label: "个人" },
      { value: "IDENTITY_CARD", label: "企业" },
    ],
    //aggregationType枚举值定义//OperationSourceEnumList
    aggregationTypeList: [
        { value: 1, label: "访问人数" ,code:"VISIT_NUM",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/VisitorCount.jpg"},
        { value: 10, label: "服务项目页面" ,code:"PRIMARY_SERVICE",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/ServiceCategory.jpg"},
        { value: 20, label: "订单明细页面" ,code:"ORDER_DETAIL",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/OrderDetails.jpg"},
        { value: 30, label: "选择技师页面" ,code:"CHOICE_TECHNICIAN",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/technician.png"},
        { value: 40, label: "选择上门时间页面" ,code:"CHOICE_DOOR_TO_DOOR_TIME",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/HomeServiceTime.png"},
        { value: 50, label: "核对订单页面" ,code:"CHECK_ORDER",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/VerifyOrder.png"},
        { value: 60, label: "支付页面" ,code:"PAY_ORDER",
          imgUrl:"https://file-1322379458.cos.ap-chengdu.myqcloud.com/images/batchThumbimage/MobileCarErp/Payment.png"},
        { value: 1000, label: "查看服务项目" ,code:"PRIMARY_SERVICE_ENTER"},
        { value: 1100, label: "切换服务项目" ,code:"SERVICE_CHANGE"},
        { value: 1200, label: "查看服务详情" ,code:"SERVICE_DETAIL"},
        { value: 1300, label: "查看服务收费明细" ,code:"SERVICE_PRICE_DETAIL"},
        { value: 1400, label: "查看订单明细" ,code:"PRICE_DETAIL"},
        { value: 1500, label: "立即结算" ,code:"TRY_CREATE_ORDER"},
        { value: 1600, label: "确认技师" ,code:"ENSURE_TECHNICIAN"},
        { value: 1700, label: "确认技师上门时间" ,code:"ENSURE_DOOR_TO_DOOR_TIME"},
        { value: 1800, label: "立刻结算" ,code:"PAY"},
    ],
    //
    bankList: [
      { value: "ICBC", label: "工商银行" },
      { value: "ABC", label: "农业银行" },
      { value: "BOC", label: "中国银行" },
      { value: "CCB", label: "建设银行" },
      { value: "COMM", label: "交通银行" },
      { value: "CMBCHINA", label: "招商银行" },
      { value: "PSBC", label: "邮储银行" },
      { value: "ECITIC", label: "中信银行" },
      { value: "CEB", label: "光大银行" },
      { value: "SPDB", label: "浦发银行" },
      { value: "CMBC", label: "民生银行" },
      { value: "CIB", label: "兴业银行" }
      ], 
      // 入网状态
     applicationStatusList: [
      { value: "AUDITING", label: "审核中" },
      { value: "COMPLETED", label: "已通过" },
      { value: "AUDIT_BACK", label: "已驳回" },
      { value: "FAILED", label: "入网失败" },
    ],
    //车主管理-下单状态：0未下单 1已下单 10下单后已取消 20 删除
    orderStatusList: [
      { value: 0, label: "未下单" },
      { value: 1, label: "已下单" },
      { value: 10, label: "下单后已取消" },
      { value: 20, label: "删除" },
    ],
  }
// ===================== 3. 核心DTO实体 =====================
/**
 * 订单主数据 OrderDTO
 */
export const OrderDTO = [
    { field: 'paymentTime', label: '支付时间' },
    { field: 'orderState', label: '订单状态' },
    { field: 'beforeOrderState', label: '订单变更前状态' }
];

/**
 * 车辆数据 CarDTO
 */
export const CarDTO = [
    { field: 'carNo', label: '车牌号' },
    { field: 'carType', label: '车辆类型' },
    { field: 'carModel', label: '车辆型号' }
];

/**
 * 移动车管理数据 MovingVehicleManagementDTO
 */
export const MovingVehicleManagementDTO = [
    { field: 'vehicleCode', label: '移动车编号' },
    { field: 'typeId', label: '车型ID' },
    { field: 'siteId', label: '停靠点ID' },
    { field: 'serviceRadius', label: '服务半径(米)' },
    { field: 'serviceTime', label: '服务时间' },
    { field: 'state', label: '状态' ,description:'0启用/1禁用' }
];

/**
 * 订单服务数据 OrderServiceDTO
 */
export const OrderServiceDTO = [
    { field: 'serviceId', label: '服务项目ID' },
    { field: 'serviceName', label: '服务名称' },
    { field: 'serviceDuration', label: '服务时长' }
];

/**
 * 订单商品数据 OrderItemDTO
 */
export const OrderItemDTO = [
    { field: 'itemId', label: '商品ID' },
    { field: 'itemName', label: '商品名称' },
    { field: 'sku', label: 'SKU编码' },
    { field: 'oecode', label: 'OE号' },
    { field: 'num', label: '数量' },
    { field: 'price', label: '单价' }
];

/**
 * 订单退款数据 OrderRefundDTO
 */
export const OrderRefundDTO = [
    { field: 'refundId', label: '退款单号' },
    { field: 'orderId', label: '关联订单号' },
    { field: 'refundType', label: '退款类型' },
    { field: 'refundState', label: '退款状态' },
    { field: 'refundAmount', label: '退款金额' },
    { field: 'applyTime', label: '申请时间' },
    { field: 'completeTime', label: '完成时间' }
];

/**
 * 订单变更数据 OrderChangeDTO
 */
export const OrderChangeDTO = [
    { field: 'changeId', label: '变更ID' },
    { field: 'orderId', label: '订单ID' },
    { field: 'changeType', label: '变更类型(改期/改方案/二次上门)' },
    { field: 'oldTime', label: '原上门时间' },
    { field: 'newTime', label: '新上门时间' },
    { field: 'changeAmount', label: '金额变更' },
    { field: 'result', label: '变更结果(同意/拒绝)' },
    { field: 'createTime', label: '变更时间' }
];

/**
 * 订单取消规则配置 OrderCancelRuleConfigurationDTO
 */
export const OrderCancelRuleConfigurationDTO = [
    { field: 'id', label: '规则ID' },
    { field: 'autoAuditNoTechnician', label: '技师未接单是否自动审批取消' },
    { field: 'autoAuditNoArrive', label: '技师未上门是否自动审批取消' },
    { field: 'autoAuditHour', label: '超时自动审批小时数' }
];

/**
 * 技师数据 TechnicianDTO
 */
export const TechnicianDTO = [
    { field: 'techId', label: '技师ID' },
    { field: 'techName', label: '技师姓名' },
    { field: 'phone', label: '手机号' },
    { field: 'idCard', label: '证件号' },
    { field: 'gradeId', label: '技师等级ID' },
    { field: 'state', label: '在职状态(0在职/10离职)' },
    { field: 'online', label: '在线状态(1在线/10下线)' },
    { field: 'serviceArea', label: '服务范围' },
    { field: 'serviceCarIds', label: '支持车型ID集合' }
];

/**
 * 停靠点DTO（经纬度放大10^6倍传参）
 */
export const SiteDTO = [
    { field: 'siteId', label: '站点ID' },
    { field: 'siteName', label: '站点名称' },
    { field: 'cityId', label: '所属城市ID' },
    { field: 'address', label: '详细地址' },
    { field: 'longitude', label: '经度(原始*1000000)' },
    { field: 'latitude', label: '纬度(原始*1000000)' },
    { field: 'serviceRadius', label: '服务半径(米)' },
    { field: 'parkNum', label: '停靠数量' },
    { field: 'state', label: '状态' ,description:'0启用/1禁用' }
];

/**
 * 服务价格-上门费 ServiceCallFeeVO
 */
export const ServiceCallFeeVO = [
    { field: 'serviceType', label: '计费类型(1按公里)' },
    { field: 'price', label: '单价' },
    { field: 'minPrice', label: '最低价格' },
    { field: 'maxPrice', label: '最高价格' }
];

/**
 * 服务价格-工时费 LaborFeeVO
 */
export const LaborFeeVO = [
    { field: 'fixedPrice', label: '固定价格' },
    { field: 'type', label: '价格类型(1固定/10技师等级)' },
    { field: 'level', label: '技师等级' },
    { field: 'price', label: '对应等级价格' }
];

//trucker数据
export const TruckerNum =[
      { field: 'profileId', label: '主键 ID' },
      { field: 'userId', label: '用户 ID' },
      { field: 'orgId', label: '审核归属组织 ID' },
      { field: 'orgName', label: '审核归属组织名称' },
      { field: 'companyOrgId', label: '公司组织 ID（公司司机有值）' },
      { field: 'companyName', label: '公司名称（公司司机有值）' },
      { field: 'cityId', label: '城市 ID' },
      { field: 'cityName', label: '城市名称' },
      { field: 'truckerName', label: '司机姓名' },
      { field: 'phone', label: '手机号' },
      { field: 'idNum', label: '身份证号' },
      { field: 'idNumFrontSideImgUrl', label: '身份证正面照' },
      { field: 'idNumBackSideImgUrl', label: '身份证反面照' },
      { field: 'drivingLicenseNo', label: '驾驶证号' },
      { field: 'drivingLicenseImgUrl', label: '驾驶证图片' }, 
      { field: 'vehicle', label: '车辆信息',
        children: [
          { field: 'id', label: '车辆ID' },
          { field: 'ownerName', label: '车主姓名' },
          { field: 'ownerPhone', label: '车主手机号' },
          { field: 'licensePlateNum', label: '车牌号' },
          { field: 'driverLicense', label: '行驶证号' },
          { field: 'driverLicenseImgUrl', label: '行驶证图片 URL' },
          { field: 'vehicleType', label: '货车类型' },
          { field: 'registType', label: '注册类型：0个人 1公司' },
          { field: 'ownerUserId', label: '个人车辆关联的 union_user.user_id' },
          { field: 'companyOrgId', label: '公司车辆的公司组织ID' },
          { field: 'orgId', label: '公司车辆组织ID' },  
          { field: 'companyOrgId', label: '公司车辆的公司组织ID' },
          { field: 'createdAt', label: '创建时间（毫秒时间戳）' },
        ]
       },
      { field: 'bindVehicleId', label: '绑定移动车 ID' },
      { field: 'auditRemark', label: '审核备注/拒绝原因' },
      { field: 'refusedReason', label: '拒绝原因枚举码' },
      { field: 'accountStatus', label: '账号状态：0待审核 10可接单 20审核拒绝 30停用/封禁' },
      { field: 'submitCount', label: '累计提交次数' },
      { field: 'registType', label: '注册类型：0个人 1公司' },
      { field: 'isCompanyAdmin', label: '是否公司管理员：0否 1是' },
      { field: 'createdAt', label: '注册时间戳（毫秒）' },
      { field: 'roleType', label: '角色类型编码（如 trucker）' },
      { field: 'roleName', label: '角色名称（如 货车司机）' },
      { field: 'roleStatus', label: '角色状态：1启用 0禁用' },
]